// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"433b1d2e","667":"d629bc58"}[chunkId] + ".chunk.js";
};